import {
  OrderCancellationProcessProvider,
  OrderCancellationProcessProviderProps
} from './orderCancellation/OrderCancellationProcessProvider'
import {
  OrderChangeProcessProvider,
  OrderChangeProcessProviderProps
} from './orderChange/OrderChangeProcessProvider'

/**
 * Props for OrderManagementProcessProvider combining order change and cancellation functionality.
 * Provides clear separation between order change refresh interval and cancellation timer threshold.
 */
type OrderManagementProcessProviderProps = React.PropsWithChildren & {
  /** Options configuration for order change functionality */
  orderChangeOptions: OrderChangeProcessProviderProps['options']
  /**
   * Refresh interval for changeable fields (order change feature).
   * Controls how often field states are recalculated based on time constraints.
   */
  changeableFieldsRefreshIntervalMs?: OrderChangeProcessProviderProps['changeableFieldsRefreshIntervalMs']
  /**
   * Timer threshold for cancellation countdown (order cancellation feature).
   * Controls when the cancellation countdown timer becomes visible.
   * Example: '04:00:00' shows timer in last 4 hours before cancellation deadline.
   */
  cancellationTimerThreshold?: OrderCancellationProcessProviderProps['cancellationTimerThreshold']
} & Omit<OrderChangeProcessProviderProps, 'options' | 'changeableFieldsRefreshIntervalMs'> &
  Omit<OrderCancellationProcessProviderProps, 'cancellationTimerThreshold'>

export const OrderManagementProcessProvider: React.FC<OrderManagementProcessProviderProps> = ({
  children,
  orderChangeOptions,
  ...props
}) => {
  return (
    <OrderChangeProcessProvider options={orderChangeOptions} {...props}>
      <OrderCancellationProcessProvider {...props}>{children}</OrderCancellationProcessProvider>
    </OrderChangeProcessProvider>
  )
}
